import { render, staticRenderFns } from "./resetpassword.vue?vue&type=template&id=09f3161d&"
import script from "./resetpassword.vue?vue&type=script&lang=js&"
export * from "./resetpassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09f3161d')) {
      api.createRecord('09f3161d', component.options)
    } else {
      api.reload('09f3161d', component.options)
    }
    module.hot.accept("./resetpassword.vue?vue&type=template&id=09f3161d&", function () {
      api.rerender('09f3161d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/login/resetpassword.vue"
export default component.exports